










import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FileRepository, { Document } from "@/repositories/FileRepository";

const components = { };

@Component({ components })

export default class ProofsList extends Vue {
    @Prop() public documentDownloaded!: Document;

    public download(documentDownloaded: Document) {
        FileRepository.download(documentDownloaded);
    }
}
